export const navigationBooks = [
    { name: "Genesis", chapters: 50 },
    { name: "Exodus", chapters: 40 },
    { name: "Leviticus", chapters: 27 },
    { name: "Numbers", chapters: 36 },
    { name: "Deuteronomy", chapters: 34 },
    { name: "Joshua", chapters: 24 },
    { name: "Judges", chapters: 21 },
    { name: "Ruth", chapters: 4 },
    { name: "1 Samuel", chapters: 31 },
    { name: "2 Samuel", chapters: 24 },
    { name: "1 Kings", chapters: 22 },
    { name: "2 Kings", chapters: 25 },
    { name: "1 Chronicles", chapters: 29 },
    { name: "2 Chronicles", chapters: 36 },
    { name: "Ezra", chapters: 10 },
    { name: "Nehemiah", chapters: 13 },
    { name: "Esther", chapters: 10 },
    { name: "Job", chapters: 42 },
    { name: "Psalms", chapters: 150 },
    { name: "Proverbs", chapters: 31 },
    { name: "Ecclesiastes", chapters: 12 },
    { name: "Song of Solomon", chapters: 8 },
    { name: "Isaiah", chapters: 66 },
    { name: "Jeremiah", chapters: 52 },
    { name: "Lamentations", chapters: 5 },
    { name: "Ezekiel", chapters: 48 },
    { name: "Daniel", chapters: 12 },
    { name: "Hosea", chapters: 14 },
    { name: "Joel", chapters: 3 },
    { name: "Amos", chapters: 9 },
    { name: "Obadiah", chapters: 1 },
    { name: "Jonah", chapters: 4 },
    { name: "Micah", chapters: 7 },
    { name: "Nahum", chapters: 3 },
    { name: "Habakkuk", chapters: 3 },
    { name: "Zephaniah", chapters: 3 },
    { name: "Haggai", chapters: 2 },
    { name: "Zechariah", chapters: 14 },
    { name: "Malachi", chapters: 4 },
    { name: "Matthew", chapters: 28 },
    { name: "Mark", chapters: 16 },
    { name: "Luke", chapters: 24 },
    { name: "John", chapters: 21 },
    { name: "Acts", chapters: 28 },
    { name: "Romans", chapters: 16 },
    { name: "1 Corinthians", chapters: 16 },
    { name: "2 Corinthians", chapters: 13 },
    { name: "Galatians", chapters: 6 },
    { name: "Ephesians", chapters: 6 },
    { name: "Philippians", chapters: 4 },
    { name: "Colossians", chapters: 4 },
    { name: "1 Thessalonians", chapters: 5 },
    { name: "2 Thessalonians", chapters: 3 },
    { name: "1 Timothy", chapters: 6 },
    { name: "2 Timothy", chapters: 4 },
    { name: "Titus", chapters: 3 },
    { name: "Philemon", chapters: 1 },
    { name: "Hebrews", chapters: 13 },
    { name: "James", chapters: 5 },
    { name: "1 Peter", chapters: 5 },
    { name: "2 Peter", chapters: 3 },
    { name: "1 John", chapters: 5 },
    { name: "2 John", chapters: 1 },
    { name: "3 John", chapters: 1 },
    { name: "Jude", chapters: 1 },
    { name: "Revelation", chapters: 22 },
  ];
  
 export const krvBooks = [
    { name: "창세기", chapters: 50 },
    { name: "출애굽기", chapters: 40 },
    { name: "레위기", chapters: 27 },
    { name: "민수기", chapters: 36 },
    { name: "신명기", chapters: 34 },
    { name: "여호수아", chapters: 24 },
    { name: "사사기", chapters: 21 },
    { name: "룻기", chapters: 4 },
    { name: "사무엘상", chapters: 31 },
    { name: "사무엘하", chapters: 24 },
    { name: "열왕기상", chapters: 22 },
    { name: "열왕기하", chapters: 25 },
    { name: "역대상", chapters: 29 },
    { name: "역대하", chapters: 36 },
    { name: "에스라", chapters: 10 },
    { name: "느헤미야", chapters: 13 },
    { name: "에스더", chapters: 10 },
    { name: "욥기", chapters: 42 },
    { name: "시편", chapters: 150 },
    { name: "잠언", chapters: 31 },
    { name: "전도서", chapters: 12 },
    { name: "아가", chapters: 8 },
    { name: "이사야", chapters: 66 },
    { name: "예레미야", chapters: 52 },
    { name: "예레미야애가", chapters: 5 },
    { name: "에스겔", chapters: 48 },
    { name: "다니엘", chapters: 12 },
    { name: "호세아", chapters: 14 },
    { name: "요엘", chapters: 3 },
    { name: "아모스", chapters: 9 },
    { name: "오바댜", chapters: 1 },
    { name: "요나", chapters: 4 },
    { name: "미가", chapters: 7 },
    { name: "나훔", chapters: 3 },
    { name: "하박국", chapters: 3 },
    { name: "스바냐", chapters: 3 },
    { name: "학개", chapters: 2 },
    { name: "스가랴", chapters: 14 },
    { name: "말라기", chapters: 4 },
    { name: "마태복음", chapters: 28 },
    { name: "마가복음", chapters: 16 },
    { name: "누가복음", chapters: 24 },
    { name: "요한복음", chapters: 21 },
    { name: "사도행전", chapters: 28 },
    { name: "로마서", chapters: 16 },
    { name: "고린도전서", chapters: 16 },
    { name: "고린도후서", chapters: 13 },
    { name: "갈라디아서", chapters: 6 },
    { name: "에베소서", chapters: 6 },
    { name: "빌립보서", chapters: 4 },
    { name: "골로새서", chapters: 4 },
    { name: "데살로니가전서", chapters: 5 },
    { name: "데살로니가후서", chapters: 3 },
    { name: "디모데전서", chapters: 6 },
    { name: "디모데후서", chapters: 4 },
    { name: "디도서", chapters: 3 },
    { name: "빌레몬서", chapters: 1 },
    { name: "히브리서", chapters: 13 },
    { name: "야고보서", chapters: 5 },
    { name: "베드로전서", chapters: 5 },
    { name: "베드로후서", chapters: 3 },
    { name: "요한일서", chapters: 5 },
    { name: "요한이서", chapters: 1 },
    { name: "요한삼서", chapters: 1 },
    { name: "유다서", chapters: 1 },
    { name: "요한계시록", chapters: 22 },
  ];
  